import { Component } from 'react';

import Field from 'Lib/components/form/Field';

/**
 * withSelectField is a wrapper for select fields that streamlines building select components.
 * when using withSelectField your field component should only have a render method.
 *
 * example:
 *       class FieldComponent extends React.Component {
                render = () => {
                    const{ form, field } = this.props;

                    return (
                        <InputComponent
                            {...this.props}
                            form={form}
                            value={field.value}
                            onChange={option => this.props.handleChange(option, form, field)}
                            onBlur={() => this.props.handleBlur(form, field)}
                        />
                    );
                };
            }

            export default withSelectField(InputComponent);
 * @param {*} WrappedComponent - a selectField component to add functionality to.
 * @param {*} displayName
 */
export const withSelectField = (WrappedComponent, displayName = 'withSelectField') => {
    class SelectField extends Component {
        handleChange = (option, form, field) => {
            if (this.props.onChange) {
                this.props.onChange(option, form, field);
            }

            if (!option) {
                if (this.props.isMulti == 1) {
                    form.setFieldValue(field.name, []);
                } else {
                    form.setFieldValue(field.name, null);
                }

                return;
            }

            if (this.props.isMulti == 1) {
                const value = [];
                option.forEach(opt => {
                    value.push(opt.value);
                });
                form.setFieldValue(field.name, value);
            } else {
                form.setFieldValue(field.name, option.value);
            }
        };

        handleBlur = (form, field) => {
            if (this.props.onBlur) {
                this.props.onBlur(form, field);
            }
            form.setFieldTouched(field.name);
        };

        render() {
            const handlers = {
                handleChange: this.handleChange,
                handleBlur: this.handleBlur
            };

            return <Field {...this.props} render={props => <WrappedComponent {...props} {...handlers} />} />;
        }
    }

    SelectField.displayName = `${displayName}(${WrappedComponent.name})`;

    return SelectField;
};

export default withSelectField;
